import React, { Component, PropTypes } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';
import FormFieldContainer from './FormFieldContainer';

const css = oxygenCss({
  sizeContainer: {
    cursor: 'pointer',
    ':first-child': {
      borderStyle: 'solid'
    },
    boxSizing: 'border-box',
    borderStyle: 'none solid solid solid',
    borderWidth: 2,
    borderColor: '#535353',
    height: 18,
    position: 'relative',
    '&selected': {
      borderColor: Colors.creen
    }
  }
});

class SizeChooser extends Component {
  static propTypes = {
    selected: PropTypes.number,
    title: PropTypes.string,
    onTouchTap: PropTypes.func,
    sizes: PropTypes.array
  };

  static defaultProps = {
    sizes: [1, 2, 3]
  };

  handleTouchTap = size => {
    const { onChange, selected } = this.props;
    if (size !== selected && onChange) {
      onChange(size);
    }
  };

  render() {
    const { title, selected, sizes } = this.props;
    return (
      <FormFieldContainer title={title}>
        <div>
          {sizes.map(size => {
            const classes = classNames(css.sizeContainer, {
              [css.selected]: size <= selected
            });
            return (
              <div
                key={size}
                className={classes}
                onTouchTap={this.handleTouchTap.bind(this, size)}
              />
            );
          })}
        </div>
      </FormFieldContainer>
    );
  }
}

export default SizeChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/SizeChooser.js